import styled, { css } from 'styled-components';
import { isGlobetrotter } from '../../utils/theming.js';

// @ts-nocheck
var Link = styled.a.withConfig({
  displayName: "Linkstyle__Link",
  componentId: "sc-1d1h248-0"
})(["line-height:normal;font-size:1.6rem;overflow:visible;text-align:left;display:inline-flex;align-items:center;transition:color var(--transition);color:var(--color-cta-link-primary);&:hover{color:var(--color-cta-link-primary-hover);}"]);
var IconBefore = styled.span.withConfig({
  displayName: "Linkstyle__IconBefore",
  componentId: "sc-1d1h248-1"
})(["display:flex;margin-right:var(--space-200);", ""], isGlobetrotter(css(["margin-left:var(--space-100);"])));
var IconAfter = styled.span.withConfig({
  displayName: "Linkstyle__IconAfter",
  componentId: "sc-1d1h248-2"
})(["display:flex;margin-left:var(--space-200);", ""], isGlobetrotter(css(["margin-left:var(--space-100);"])));
var LinkText = styled.span.withConfig({
  displayName: "Linkstyle__LinkText",
  componentId: "sc-1d1h248-3"
})(["text-decoration:underline;text-underline-offset:2px;", ""], function (_ref) {
  var $hasIcon = _ref.$hasIcon;
  return !!$hasIcon && css(["text-decoration:none;", ":hover &{text-decoration:underline;}"], Link);
});

export { IconAfter, IconBefore, Link, LinkText };
//# sourceMappingURL=Link.style.js.map
